import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import MediaQuery from 'react-responsive'
import { connect } from 'react-redux'

const checkMenuContext = (onlyCash, context = []) => {
  const currentContext = onlyCash ? 'cash' : 'points'
  return context.indexOf(currentContext) > -1
}

const MenuHomeMobile = ({ onlyCash, items }) => (
  <div className='menu-carousel menu-carousel-mobile container draggable d-block d-sm-none  '>
    <div className='row mx-0 flex-nowrap flex-md-wrap'>
      { items.map((item, index) => (
        checkMenuContext(onlyCash, (item.context || ['points', 'cash'])) &&
         (item.path && item.path !== '#' && (<MenuItemMobile key={index} item={item} />))
      ))}
    </div>
  </div>
)

MenuHomeMobile.propTypes = {
  items: PropTypes.object,
  onlyCash: PropTypes.bool
}

const MenuHomeDesktop = ({ onlyCash, items }) => (
  <div className='menu-carousel menu-carousel-desktop container px-0'>
    <div className='row row-eq-height mx-0 px-0'>
      { items.map((item, index) => (
        checkMenuContext(onlyCash, (item.context || ['points', 'cash'])) &&
        (item.path && item.path !== '#' && (<MenuItemDesktop key={index} item={item} />))
      ))}
    </div>
  </div>
)

MenuHomeDesktop.propTypes = {
  items: PropTypes.object,
  onlyCash: PropTypes.bool
}

const MenuItemMobile = ({ item }) => (
  <div className='col menu-categories-home-item px-1 border border-color-ui-3 radius'>
    <div className='row align-items-center h-100 mx-0'>
      <Link to={item.path} className='d-block'>
        <i className={`icon icon-mmd ${item.icon} color-brand-1`} />
        <p className='mt-1 txt-body txt-bold color-title'>{item.label}</p>
      </Link>
    </div>
  </div>
)

MenuItemMobile.propTypes = {
  item: PropTypes.object
}
const MenuItemDesktop = ({ item }) => (
  <div className='col menu-categories-home-item px-1 border border-color-ui-3 radius'>
    <Link to={item.path} title={`Acesse ${item.label}`} className='row align-items-center h-100 mx-0'>
      <div className='col-auto'>
        <i className={`icon icon-mmd ${item.icon} color-brand-1`} />
      </div>
      <div className='col'>

        <p className='mt-1 txt-body txt-bold color-title'>{item.label}</p>
      </div>
    </Link>
  </div>
)

MenuItemDesktop.propTypes = {
  item: PropTypes.object
}

class MenuHome extends Component {
  constructor (props) {
    super()

    this.state = {
      displayMenu: []
    }

    this.items = props.tradeMenu.items
  }

  componentWillMount () {
    this.mountDisplay(this.props.tradeMenu.items)
  }

  render () {
    return (
      <div className='menu-categories-home container-fluid bg-white px-0 pt-1 pb-1'>
        <MediaQuery maxDeviceWidth={425}>
          <MenuHomeMobile onlyCash={this.props.onlyCash} items={this.items} />
        </MediaQuery>
        <MediaQuery minDeviceWidth={426}>
          <MenuHomeDesktop onlyCash={this.props.onlyCash} items={this.items} />
        </MediaQuery>
      </div>
    )
  }

  mountDisplay = items => {
    items.map((__, index) =>
      this.state.displayMenu.push({ index, display: false })
    )
  }
}

MenuHome.propTypes = {
  tradeMenu: PropTypes.object,
  onlyCash: PropTypes.bool
}

const mapStateToProps = ({ onlyCash }) => ({ onlyCash })

export default connect(mapStateToProps)(MenuHome)



// WEBPACK FOOTER //
// ./src/App/MainMenu/MenuMobile/MenuHome.js